module.exports = __webpack_public_path__ + "img/school.e46f649d.png";